var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"src":_vm.calendar,"width":"100%","height":"100%","scrolling":"yes"}})])}
var staticRenderFns = []

export { render, staticRenderFns }